<template>
  <section class="invoice-preview-wrapper">
    <b-card no-body class="invoice-preview-card">
      <b-badge v-if="userEvaluation" :variant="isEvaluationValid ? 'primary' : 'warning'" class="badge-glow">
      {{ isEvaluationValid ? 'Validé' : 'Non Validé' }}
    </b-badge>

      <div>

        <div class="m-2">
          <div class="card-header d-flex justify-content-between align-items-center">
            <div>
              <b-card-title>Evaluation</b-card-title>
            </div>
            <b-form-select
                id="yearSelect"
                v-model="currentYear"
                size="sm"
                :options="yearOptions"
                class="budget-dropdown"
            />
          </div>

          <div v-if="!userEvaluation" class="alert-body">
            <b-alert variant="warning" show>
              <span><strong>Pas d'évaluation effectuée pour l'année {{
                  currentYear ? currentYear : new Date().getFullYear()
                }} !</strong></span>
            </b-alert>

          </div>

          <div v-if="userEvaluation">
            <app-timeline>
              <app-timeline-item
                  v-for="(item, index) in signatureValidUser"
                  :key="index"
                  :title="`${item.titre} ${item.users.lastName} ${item.users.firstName}`"
                  :subtitle="item.text"
                  :time="formatDate(item.dateCreate)"
                  :variant="item.variant"
              />
            </app-timeline>
          </div>


          <!-- Editer & Détails de l'évaluation -->
          <div class="d-flex demo-inline-spacing justify-content-end mt-3">

            <b-button
                v-if="userEvaluation"
                variant="outline-primary"
                @click="handleClick()"
            >
              <feather-icon icon="EyeIcon" class="mr-50"/>
              <span class="align-middle">Detail</span>
            </b-button>

            <b-button
                v-if="evaluationCanBeEdited"
                variant="outline-success"
                @click="$router.push({ name: 'autoevaluation' , query: { year: currentYear }})"
            >
              <feather-icon icon="EditIcon" class="mr-50"/>
              <span class="align-middle">Editer</span>
            </b-button>
          </div>

        </div>
      </div>

    </b-card>
  </section>
</template>

<script>
import {BAlert, BBadge, BButton, BCard, BCardTitle, BFormSelect} from 'bootstrap-vue';
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue';
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue';
import {getUserEvaluationsByYears, updateDateEvaluationMeeting,} from '@/services/UserEvaluationService';
import {allYears} from '@/services/YearsService';
import {getSetting} from '@/services/SettingService';
import Ripple from 'vue-ripple-directive';
import moment from 'moment'
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import {getJsonFromStorage} from "@/util/storageUtils";


export default {
  directives: {
    Ripple,
  },
  components: {
    // EvaluationDateScheduler,
    BFormSelect,
    BCard,
    AppTimeline,
    AppTimelineItem,
    BBadge,
    BButton,
    BAlert,
    BCardTitle
  },
  props: {
    userData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dateEvaluationAccepted: true,
      userEvaluation: null,
      currentYear: null,
      years: [],
      signatureValidUser: [],
    };
  },
  computed: {
    isEvaluationValid() {
      return this.userEvaluation && this.userEvaluation.valid;
    },
    evaluationCanBeEdited() {
      if (!this.userEvaluation) return true;

      const status = this.userEvaluation.status;

      if (['EVALUATION', 'SELF_EVALUATION', 'INPROGRESS', 'TERMINATED'].includes(status)) {
        return true;
      }

      if (status !== 'MEETING') return false;

      const dateStr =
          this.userEvaluation.dateEvaluationPropose ||
          this.userEvaluation.dateEvaluationPrevu;

      if (!dateStr) return true;

      const datePlan = moment(dateStr, 'DD-MM-YYYY HH:mm', true);
      const datePrevue = this.getEvaluationDateWithHourSubstracted(dateStr);

      if (!datePlan.isValid() || !datePrevue?.isValid()) {
        return true;
      }

      return moment().isBefore(datePrevue);
    },

    yearOptions() {
      return this.years.map(year => ({
        value: year.year,
        text: `${year.year}`,
      }));
    },
  },
  watch: {
    currentYear(newYear, oldYear) {
      this.fetchUserEvaluationData(newYear);
    },
  },
  methods: {
    getStoredUserData() {
      const storedUserData = getJsonFromStorage('userData')
      return storedUserData ? storedUserData : null
    },
    async validateProposedDate() {
      // if (this.dateEvaluationAccepted) {
      //   this.userEvaluation.userAcceptedDateEvaluation = this.dateEvaluationAccepted
      // }

      updateDateEvaluationMeeting(this.userEvaluation.idPublic, this.userEvaluation,'USER_ACCEPT')
          .then(result => {
            if (result.status === "MEETING") {

              this.fetchUserEvaluationData(this.currentYear)

              this.showToast("Date enregistrée avec succès", "success", "BellIcon");
            } else {
              this.showToast("Erreur lors de l'enregistrement de la date", "danger", "BellIcon");
            }
          })
          .catch(error => {
            this.showToast("Erreur lors de l'enregistrement de la date", "danger", "BellIcon");
            console.error("Erreur lors de la récupération des données :", error);
          });
    },
    formatDate(date) {
      if (!date) return '';
      if (Array.isArray(date)) {
        const [year, month, day] = date;
        return `${day.toString().padStart(2, '0')}-${month.toString().padStart(2, '0')}-${year}`;
      }
      if (typeof date === 'string') {
        const [year, month, day] = date.split('-');
        return `${day}-${month}-${year}`;
      }
      console.error('Invalid date format:', date);
      return '';
    },
    async fetchUserEvaluationData(year) {

      if (!this.userData || !this.currentYear) {
        console.warn('Missing userData or currentYear, aborting fetch',this.userData);
        return;
      }

      try {
        const userDataConnected = this.getStoredUserData();

        const response = await getUserEvaluationsByYears(this.userData.id, userDataConnected.id, year);

        if (!response) {
          this.userEvaluation = null;
          return;
        }

        this.userEvaluation = response;

        this.signatureValidUser = [];
        const { status, validHierachy: isValid, users, dateCreate, evaluationSignature = [], dateValid, rejetHierachyn, dateEvaluationPropose, dateEvaluationSuggest, dateEvaluationPrevu, rhProposeDate, autoEvaluationFin } = this.userEvaluation;

        const n1 = evaluationSignature.find(item => item.hierarchyN === 1);
        const n2 = evaluationSignature.find(item => item.hierarchyN === 2);

        switch (status) {
          case 'INPROGRESS':
            this.addSignatureUser('Collaborateur :', users, true, dateCreate, 'Auto-évaluation en cours', 'warning');

            break;

          case 'SELF_EVALUATION':
            this.addSignatureUser('Collaborateur :', users, true, dateCreate, 'Auto-évaluation effectuée', 'success');

            if (n1?.users) {
              this.addSignatureUser('Manager N°1 :', n1?.users, false, null, 'En attente de l\'évaluation de la part du manager', 'warning');
            }

            break;

          case 'EVALUATION':
            if (n1?.users) {
              this.addSignatureUser('Manager N°1 :', n1?.users, true, n1?.confirmDate, 'Evaluation faite', 'success');
              if (dateEvaluationPropose) {
                this.addSignatureUser('Manager N°1 :', n1?.users, false, null, 'Date de réunion d’évaluation proposée', 'success');
              }
            }

            this.addSignatureUser('Collaborateur :', users, false, null, 'En attente de l\'auto-évaluation de la part du collaborateur', 'warning');

            break;

          case 'TERMINATED':
            this.addSignatureUser('Collaborateur :', users, true, dateCreate, 'Auto-évaluation faite', 'success');

            this.addSignatureUser('Manager N°1 :', n1?.users, true, n1?.confirmDate, 'Evaluation faite', 'success');
            if (n1?.users ) {
              if (dateEvaluationPrevu && rhProposeDate) {
                this.addSignatureUser('Rendez-vous :', users, false, dateEvaluationPrevu, 'Le rendez-vous pour la validation de l\'évaluation a été retenu à la date du : ' + dateEvaluationPrevu, 'warning');
              }
              if (!dateEvaluationPropose && !rhProposeDate) {
                this.addSignatureUser('Manager N°1 :', n1?.users, false, null, 'En attente de la définition d\'une date pour l\'évaluation', 'warning');

              }
              if (dateEvaluationPropose) {
                if (dateEvaluationSuggest){

                  this.addSignatureUser('Manager N°1 :', n1?.users, false, null, 'Date de réunion d’évaluation proposée', 'success');
                  this.addSignatureUser('Collaborateur :', users, false, null, 'Une autre date de réunion suggérée', 'success');
                  this.addSignatureUser('Manager N°1 :', n1?.users, false, null, 'En attente de validation de la date suggérée', 'warning');

                }else{
                  this.addSignatureUser('Manager N°1 :', n1?.users, false, null, 'Date de réunion d’évaluation proposée', 'success');
                  this.addSignatureUser('Collaborateur :', users, false, null, 'En attente de validation de la date proposée', 'warning');

                }
              }
            }
            break;

          case 'MEETING':
            if(autoEvaluationFin) {
              this.addSignatureUser('Collaborateur :', users, true, dateCreate, 'Auto-évaluation faite', 'success');

            }

            this.addSignatureUser('Manager N°1 :', n1?.users, true, n1?.confirmDate, 'Evaluation faite', 'success');

            if(!autoEvaluationFin) {
              this.addSignatureUser('Collaborateur :', users, false, null, 'En attente de l\'auto-évaluation de la part du collaborateur', 'warning');

            }

            this.addSignatureUser('Rendez-vous :', users, false, dateEvaluationPrevu, 'Le rendez-vous pour la validation de l\'évaluation a été retenu à la date du : ' + dateEvaluationPrevu, 'warning');

            break;

          case 'VALIDATED_BY_HIERARCHY':
            this.addSignatureUser('Collaborateur :', users, true, dateCreate, 'Auto-évaluation faite', 'success');

            this.addSignatureUser('Manager N°1 :', n1?.users, true, n1?.confirmDate, 'Évaluation faite', 'success');
            this.addSignatureUser('Manager N°1 :', n1?.users, true, n1?.confirmDate, 'Évaluation Validée', 'success');
            this.addSignatureUser('Collaborateur :', users, false, null, 'En attente de confirmation de l\'évaluation par le collaborateur', 'warning');

            break;

          case 'TRANSMIT_HIERARCHY_2':
            this.addSignatureUser('Collaborateur :', users, true, dateCreate, 'Auto-évaluation faite', 'success');

            this.addSignatureUser('Manager N°1 :', n1?.users, true, n1?.confirmDate, 'Évaluation faite', 'success');

            this.addSignatureUser('Manager N°1 :', n1?.users, true, n1?.confirmDate, 'Évaluation en attente de validation par le N+1.', 'warning');


            break;
          case 'APPROVED':
            this.addSignatureUser('Collaborateur :', users, true, dateCreate, 'Auto-évaluation faite', 'success');

            this.addSignatureUser('Manager N°1 :', n1?.users, true, n1?.confirmDate, 'Évaluation faite', 'success');
            this.addSignatureUser('Manager N°1 :', n1?.users, true, n1?.confirmDate, 'Évaluation Validée', 'success');
            this.addSignatureUser('Collaborateur :', users, false, null, 'En attente de confirmation de l\'évaluation par le collaborateur', 'warning');
            break;

            case 'VALIDATED_BY_COLLABORATOR':
            this.addSignatureUser('Collaborateur :', users, true, dateCreate, 'Auto-évaluation faite', 'success');
            this.addSignatureUser('Manager N°1 :', n1?.users, true, n1?.confirmDate, 'Évaluation faite', 'success');

            this.addSignatureUser('Manager N°1 :', n1?.users, true, n1?.confirmDate, 'Évaluation validée', 'success');
            if (n2) {
              this.addSignatureUser('Manager N°2 :', n2.users, true, n2.confirmDate, 'Évaluation approuvée', 'success');
            }
            this.addSignatureUser('Collaborateur :', users, true, dateValid, 'Validation finale - Évaluation terminée', 'success');
            break;
          case 'REJECTED':
            this.addSignatureUser('Collaborateur :', users, true, dateCreate, 'Auto-évaluation faite', 'success');

            this.addSignatureUser('Manager N°1 :', n1?.users, true, n1?.confirmDate, 'Évaluation faite', 'success');

            this.addSignatureUser('Manager N°1 :', n1?.users, true, n1?.confirmDate, 'Évaluation en attente de validation par le N+1.', 'warning');

            break;
        }
      } catch (error) {
        console.error('Error in fetchUserEvaluationData:', error);
      }

    },


    addSignatureUser(titre, users, signature, dateCreate, text, variant) {
      if (!users) return;
      this.signatureValidUser.push({
        titre,
        users,
        signature,
        dateCreate,
        text,
        variant,
      });
    },
    async getAllYears() {
      try {
        this.years = await allYears();
        // if (!this.currentYear && this.years.length) {
        //   this.currentYear = this.years[0].year;
        // }
      } catch (error) {
        console.error('Error fetching years:', error);
      }
    },


    handleClick() {
      this.$router.push({ name: 'evaluation_prints', params: { id: this.userEvaluation.idPublic } });

    },
    getEvaluationDateWithHourSubstracted(date) {
      if(!date) {
        this.showToast('Erreur', 'La date de validation est manquante', 'danger');
        return;
      }

      const currentDate = moment(date, "DD-MM-YYYY HH:mm", true);
      // const currentDateMinus1h = currentDate.subtract(1, 'days');
      return currentDate.subtract(36, 'hours');
    }
    , showToast(variant, position, text) {
      this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: 'Notification',
              icon: 'InfoIcon',
              text,
              variant,
            },
          },
          { position }
      );
    },
  },
  async mounted() {
    await this.getAllYears();
    try {
      const response = await getSetting();
      if (response && response.yearEvaluation) {
        this.currentYear = response?.yearEvaluation?.year;

        }
    } catch (error) {
      this.currentYear = this.years.length ? this.years[0].year : new Date().getFullYear();
    }

    await this.fetchUserEvaluationData(this.currentYear);
  },
};
</script>

<style scoped>
.budget-dropdown {
  width: 80px;
  border: 1px solid #005cb9;
  border-radius: 0.357rem;
  background-color: #fff;
  font-size: 1rem;
  line-height: 1.45;
  color: #005cb9;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.budget-dropdown:focus,
.budget-dropdown:active {
  border-color: #7367f0;
  box-shadow: 0 0 0 0.2rem rgba(115, 103, 240, 0.2);
  outline: none;
}
</style>
